// extracted by mini-css-extract-plugin
export default {"video-container":"Video_video-container__k3F5G"};